import { useState } from 'react'
import { Box, Button, FormControl, FormControlLabel, Modal, Radio, RadioGroup, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LoadingButton } from '@mui/lab'
import ModalTitle from '../../../../../components/common/Modal/ModalTitle'
import { kycv2PersonStatusEnum } from '../../../kycv2.enums'
import styles from './styles.module.scss'

export const UpdateStatusModal = ({ open, onClose, onSubmit, loading, currentStatus }) => {
  const { t } = useTranslation(['common', 'messages'])
  const [selectedStatus, setSelectedStatus] = useState(currentStatus || '')

  const handleSubmit = () => {
    if (selectedStatus) {
      onSubmit(selectedStatus)
    }
  }

  const handleClose = () => {
    setSelectedStatus(currentStatus || '')
    onClose()
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Box className={styles.container}>
        <ModalTitle setModalOpen={handleClose} title={t('common:updateStatus')} />

        <Box className={styles.formContainer}>
          <Typography variant="subtitle2" mb={1}>
            {t('common:selectNewStatus')}:
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
              {kycv2PersonStatusEnum.map((status) => (
                <FormControlLabel key={status} value={status} control={<Radio />} label={t(`common:${status}`)} />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>

        <Box className={styles.actions}>
          <Button variant="outlined" onClick={handleClose} disabled={loading}>
            {t('common:cancel')}
          </Button>
          <LoadingButton
            variant="contained"
            onClick={handleSubmit}
            loading={loading}
            disabled={!selectedStatus || selectedStatus === currentStatus}
          >
            {t('common:update')}
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  )
}
